import { useEffect, useState } from 'react';
import { Card, Carousel, Row, Col, Container, Button } from 'react-bootstrap';
import { categories } from '../../config/categories';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import './CategoriasDestacadas.css';

function CategoriasDestacadas() {
  const [categorias, setCategorias] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setCategorias(categories);
  }, []);

  // Agrupar en bloques de 4
  const grouped = [];
  for (let i = 0; i < categorias.length; i += 4) {
    grouped.push(categorias.slice(i, i + 4));
  }

  return (
    <section className="py-5 featured-categories">
      <Container>
        <div className="featured-section-head text-center mb-4">
          <span className="featured-section-chip">Navegación rápida</span>
          <h2 className="mb-2">Categorías Destacadas</h2>
          <p className="featured-section-subtitle mb-0">
            Encuentra tu equipo por línea de producto y accede directo a lo que necesitas.
          </p>
        </div>
        <Carousel indicators={false} controls={grouped.length > 1}>
          {grouped.map((grupo, idx) => (
            <Carousel.Item key={idx}>
              <Row className="g-4 justify-content-center">
                {grupo.map((cat) => (
                  <Col md={3} sm={6} xs={12} key={cat.id}>
                    <Card className="h-100 text-center shadow-sm category-card">
                      <Card.Body className="category-card-body">
                        <div className="category-icon-wrap">
                          <FontAwesomeIcon icon={cat.icon} className="category-icon" />
                        </div>
                        <Card.Title className="category-title">{cat.name}</Card.Title>
                        <p className="category-meta mb-0">
                          {cat.subcategories?.length || 0} subcategorias
                        </p>
                        <Button
                          variant="primary"
                          className="mt-3 featured-category-btn"
                          onClick={() => navigate(`/categorias/${cat.id}`)}
                        >
                          Ver más
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
}

export default CategoriasDestacadas;
